import React from "react";
import { AavoEnvironment } from "src/api/generated/io/aavo/shared/aavoEnvironment";
import { Site } from "src/api/generated/erp/db/types/tables/site.ts";
import { useContextOrThrow } from "src/utils/useContextOrThrow";
import { AppUserSettings } from "src/api/generated/erp/db/types/tables/appUserSettings.ts";
import { MainMenuItemSetting } from "src/api/generated/common/mainMenu/mainMenuItemSetting.ts";
import { AavoAiSubscriptionPlan } from "src/api/generated/io/aavo/shared/aavoAiSubscriptionPlan.ts";

export const GlobalInitDataContext = React.createContext<GlobalInitDataContextValue | undefined>(undefined);

export interface GlobalInitData {
	tenant: string;
	principalId: string;
	appUserId: number;
	userName: string;
	userEmail: string;
	aavoAiEnabled: boolean;
	aavoAiSubscriptionPlan: AavoAiSubscriptionPlan;
	userPermissions: string[];
	mfaIsEnabled: boolean;
	defaultSiteId: number;
	userSites: Site[];
	changingPasswordIsPossible: boolean;
	environmentType: AavoEnvironment;
	appUserSettings?: AppUserSettings;
	mainMenuItemSettings: MainMenuItemSetting[];
	supportsCustomFromAddress: boolean;
}

export interface GlobalInitDataContextValue extends GlobalInitData {
	setMainMenuItemSettings: (settings: MainMenuItemSetting[]) => void;
}

export const useGlobalInitData = () => useContextOrThrow(GlobalInitDataContext);
